<template>
  <div :class="uniqueClass" class="kye-preview-image-wrapper">
    <kye-dialog
      ref="dialog"
      :visible.sync="value"
      v-bind="dialogOption"
      v-on="$listeners"
      :canResize="false"
      @closed="removeDom">
      <kye-image
        ref="kyeImage"
        class="kye-preview-image-box"
        :showDownload="showDownload"
        :config="imgConfigProps"
        :imglist="imglist"
        v-on="$listeners"
        resizeHeight
        @change="currentIndexChange">
        <Formatter
          v-if="imageProps && imageProps.btnSlot"
          :formatter="imageProps.btnSlot"
          slot="btn"
          slot-scope="{ imgConfig, currentIndex, loadImgSrc }"
          :imgConfig="imgConfig"
          :currentIndex="currentIndex"
          :loadImgSrc="loadImgSrc" />
        <Formatter
          v-if="imageProps && imageProps.topbtnSlot"
          :formatter="imageProps.topbtnSlot"
          slot="topbtn"
          slot-scope="{ imgConfig, currentIndex, loadImgSrc }"
          :imgConfig="imgConfig"
          :currentIndex="currentIndex"
          :loadImgSrc="loadImgSrc" />
        <Formatter
          v-if="imageProps && imageProps.bottomSlot"
          :formatter="imageProps.bottomSlot"
          slot="bottom"
          slot-scope="{ imgConfig, currentIndex, loadImgSrc }"
          :imgConfig="imgConfig"
          :currentIndex="currentIndex"
          :loadImgSrc="loadImgSrc" />
        <template v-if="isFile" slot="img" slot-scope="{ imgConfig }">
          <FileVideo
            :style="{
              width: imgConfig.width ? imgConfig.width + 'px' : '100%'
            }"
            v-if="['mp4', 'mp3', 'mov', 'wav'].includes(fileItem.extendName)"
            :fileItem="fileItem"></FileVideo>
          <FilteToIframe
            v-else
            :key="fileItem.id + currentIndex"
            ref="FilteToIframe"
            :style="{
              width: imgConfig.width ? imgConfig.width + 'px' : '100%'
            }"
            :fileItem="fileItem"
          ></FilteToIframe>
        </template>
      </kye-image>
    </kye-dialog>
  </div>
</template>

<script>
import { KYE_PREVIEW_VERSION, IMG_KEYS } from './constant'
import FilteToIframe from './file-to-iframe'
import Formatter from './formatter.js'
import FileVideo from '../file-video.vue'
import { omit } from 'lodash'
export default {
  components: {
    FilteToIframe,
    Formatter,
    FileVideo
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    url: {
      type: Array,
      default: () => []
    },
    imglist: {
      type: Array,
      default: () => []
    },
    index: {
      type: Array,
      default: () => []
    },
    imageProps: {
      type: Object,
      default: () => ({
        // height: 500
      })
    },
    dialogOption: {
      type: Object,
      default: () => ({
        title: '图片查看',
        width: '700px'
      })
    },
    version: {
      type: String,
      default: ''
    },
    showDownload: {
      type: Boolean,
      default: true
    },
    pdfTypeList: {
      type: Array,
      default: () => ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf', 'txt', 'ofd']
    },
    bizCode: String,
    bizId: String,
    id: String,
    defalutIndex: {
      type: Number,
      default: 0
    },
    isPrewFileToPdf: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      uniqueClass: KYE_PREVIEW_VERSION + this.version,
      currentIndex: 0,
      fakeFullScreen: false
    }
  },
  computed: {
    fileItem() {
      return this.$props.imglist[this.currentIndex] || {}
    },
    isFile() {
      return this.getCurrentIndexIsFile()
    },
    imgConfigProps() {
      // 确保不存在height，走kye-image组件自适应的逻辑
      const imageProps = omit(this.imageProps, ['height'])
      return Object.assign(
        {},
        {
          imgSrc: this.url,
          index: this.index,
          pdfSrc: this.imglist.reduce((arr, file) => {
            const type = String(file.extendName).toLowerCase()
            if ((this.$props.pdfTypeList || []).includes(type)) {
              arr.push(file.url)
            }
            return arr
          }, [])
        },
        imageProps
      )
    }
  },
  methods: {
    setCurrentIndex(index) {
      const fn = this.$refs.kyeImage && this.$refs.kyeImage.changeCurrentIndex
      console.log('设置currrent', index)
      if (typeof fn === 'function') {
        fn(index)
      }
    },
    getCurrentIndexIsFile() {
      if (this.currentIndex === -1) {
        return false
      }
      const { extendName } = this.$props.imglist[this.currentIndex] || {}
      const type = String(extendName).toLowerCase()
      return (this.$props.pdfTypeList || []).includes(type) || (this.$props.isPrewFileToPdf && !IMG_KEYS.includes(type))
    },
    removeDom() {
      this.$destroy()
      if (this.parent) {
        this.parent.removeChild(this.$el)
      }
    },
    currentIndexChange(index) {
      this.currentIndex = index
      setTimeout(() => {
        this.transFromFilteToIframeSrc()
      })
      if (this.$props.imageProps && this.$props.imageProps.change) {
        this.$props.imageProps.change({
          currentIndex: index
        })
      }
    },
    transFromFilteToIframeSrc() {
      this.$refs.FilteToIframe && this.$refs.FilteToIframe.transFromFilteToIframeSrc()
    },
  }
}
</script>
<style lang="scss">
.kye-preview-image-wrapper .btn-icon {
  padding-top: 0 !important;
}
.kye-preview-image-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
// .kye-preview-reset-dialog-body {
//   max-height: none !important;
//   height: calc(100% - 45px);
//   .kye-file-to-iframe-wrap,
//   .imgbox {
//     height: 100% !important;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/public/components/kye-preview/component/preview-wrapper/preview-image.vue